import {Component, inject, OnInit} from "@angular/core";
import {Observable} from "rxjs";
import {TranslatableComponent} from "../../models/TranslatableComponent";
import {TranslateService} from "@ngx-translate/core";
import {Breadcrumb, BreadcrumbsService} from "@exalif/ngx-breadcrumbs";
import {BreadcrumbsNavigationService} from "../../services/services/breadcrumbs-navigation.service";
import {Router, RouterLink} from "@angular/router";
import {AuthenticationService} from "../../services/services/authentication.service";
import {MatToolbar} from "@angular/material/toolbar";
import {MatIcon} from "@angular/material/icon";
import {MatSuffix} from "@angular/material/form-field";
import {RequiresPermissionDirective} from "../../../shared/permission/directives/requires-permission.directive";
import {BreadcrumbEmpSearchComponent} from "./breadcrumb-emp-search/breadcrumb-emp-search.component";
import {BreadcrumbProjectSearchComponent} from "./breadcrumb-project-search/breadcrumb-project-search.component";
import {BreadcrumbResourceRequestSearchComponent} from "./breadcumb-resource-request-search/breadcrumb-resource-request-search.component";
import {BreadcrumbProfileSearchComponent} from "./breadcrumb-profile-search/breadcrumb-profile-search.component";
import {MatMiniFabButton} from "@angular/material/button";
import {NgClass, AsyncPipe} from "@angular/common";

@Component({
	selector: "app-breadcrumb",
	templateUrl: "./breadcrumb.component.html",
	styleUrls: ["./breadcrumb.component.scss"],
	imports: [
		MatToolbar,
		RouterLink,
		MatIcon,
		MatSuffix,
		RequiresPermissionDirective,
		BreadcrumbEmpSearchComponent,
		BreadcrumbProjectSearchComponent,
		BreadcrumbResourceRequestSearchComponent,
		BreadcrumbProfileSearchComponent,
		MatMiniFabButton,
		NgClass,
		AsyncPipe
	],
})
export class BreadcrumbComponent extends TranslatableComponent implements OnInit {
	o: Observable<Breadcrumb[]>;
	inDetails: boolean = true;
	disablePreviousButton: boolean = false;
	disableNextButton: boolean = false;

	public breadcrumbService = inject(BreadcrumbsService);
	private readonly breadcrumbsNavigationService = inject(BreadcrumbsNavigationService);
	private readonly router = inject(Router);
	public authenticationService = inject(AuthenticationService);
	private readonly t = inject(TranslateService);

	constructor() {
		super(inject(TranslateService), "BreadcrumbComponent");
	}

	ngOnInit() {
		this.o = this.breadcrumbService.crumbs$;
		this.o.subscribe((items: Breadcrumb[]) => {
			const filteredItems: Breadcrumb[] = items.filter((item: Breadcrumb) => item.text.startsWith("/"));
			filteredItems.forEach((item) => (item.path = item.text));
		});
		this.breadcrumbsNavigationService.inDetails$.subscribe((value) => {
			this.inDetails = value;
		});

		this.breadcrumbsNavigationService.disableNextButton$.subscribe((value) => {
			this.disableNextButton = value;
		});

		this.breadcrumbsNavigationService.disablePreviousButton$.subscribe((value) => {
			this.disablePreviousButton = value;
		});
	}

	navigateToPreviousDetail() {
		this.breadcrumbsNavigationService.getPreviousDetail();
	}

	navigateToNextDetail() {
		this.breadcrumbsNavigationService.getNextDetail();
	}
}
